module.exports = __webpack_public_path__ + "static/media/lachoza@2x.3f27d951.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/lachoza@2x.png
// module id = 74
// module chunks = 0